import React from 'react';
import { Link } from 'react-router-dom';
import { Meta } from './Atoms';
import { useApi } from '../lib/api';

/**
 * F3 — podpowiedź „sprawdzone u mnie" na karcie rośliny: Twoje oceny tej odmiany.
 * Renderuje null gdy brak ocen. Cichy fail przy błędzie/braku zalogowania.
 */
export default function VarietyReviewHint({ plantName }) {
  const { data } = useApi(plantName ? `/api/variety-reviews?plant_name=${encodeURIComponent(plantName)}` : null);
  const reviews = Array.isArray(data?.data) ? data.data : [];
  if (reviews.length === 0) return null;

  const fmt = (r) => {
    const parts = [];
    if (r.yield_rating) parts.push(`Plon ${r.yield_rating}/5`);
    if (r.taste_rating) parts.push(`Smak ${r.taste_rating}/5`);
    if (r.resistance_rating) parts.push(`Odporność ${r.resistance_rating}/5`);
    return parts.join(' · ');
  };

  return (
    <div style={{ border: '1px solid var(--t-sage-bo)', background: 'var(--t-sage-bg)', borderRadius: 12, padding: 16, marginBottom: 24 }}>
      <Meta color="sage" style={{ marginBottom: 10 }}>Sprawdzone u mnie</Meta>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {reviews.slice(0, 4).map((r) => (
          <div key={r.id}>
            <div style={{ fontSize: 14, color: 'var(--t-text)' }}>
              {r.variety || 'bez odmiany'}{r.season_year ? ` · ${r.season_year}` : ''}
            </div>
            {fmt(r) && <div style={{ fontSize: 13, color: 'var(--t-text-dim)', fontFamily: 'var(--t-mono)', letterSpacing: '.04em' }}>{fmt(r)}</div>}
            {r.note && <div style={{ fontSize: 13, color: 'var(--t-text-dim)', marginTop: 2 }}>{r.note}</div>}
          </div>
        ))}
      </div>
      <Link to="/moje-odmiany" style={{ display: 'inline-block', marginTop: 12, fontFamily: 'var(--t-mono)', fontSize: 11, letterSpacing: '.16em', textTransform: 'uppercase', color: 'var(--t-sage)', textDecoration: 'none' }}>
        Wszystkie oceny →
      </Link>
    </div>
  );
}
